module.exports = __webpack_public_path__ + "static/media/gf.6a7f7f8b.svg";